import { Icons } from "@/components/Icons/Icons";
import {
  cloneFinancialDeck,
  getCurrentFinancialDeckEntity,
} from "@/models/financialDecks";
import { authStateAtom } from "@/orm/auth";
import { Route } from "@/paths";
import { Button } from "@mantine/core";
import { useAtomValue } from "jotai";
import { useState } from "react";
import { generatePath } from "react-router-dom";

export const MakeACopyButton = () => {
  const { user } = useAtomValue(authStateAtom);
  const [loading, setLoading] = useState(false);

  const onClick = async () => {
    setLoading(true);
    const entity = getCurrentFinancialDeckEntity();
    await entity.hydrate();

    const m = await cloneFinancialDeck(entity);
    const url = generatePath(Route.Model, {
      modelId: m!.id,
    });
    // open in new tab
    window.open(url, "_blank");
    setLoading(false);
  };

  if (!user) return null;

  return (
    <Button
      loading={loading}
      onClick={onClick}
      size="xs"
      color="blue"
      fz={"sm"}
      ml="auto"
      leftSection={
        <Icons.Clone style={{ marginLeft: 3, marginRight: -2 }} size={14} />
      }
    >
      Make A Copy
    </Button>
  );
};
